/**
 * @generated SignedSource<<193d542c8bbe773a9cc5d3a7730ebb79>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
export enum ConfluenceEdition {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  STANDARD = "STANDARD",
}
export type AdminKeyEligibilityQuery_tenant_Tenant = {
  __typename?: "Tenant";
  cloudId: string;
};
export type AdminKeyEligibilityQuery_confluenceTenantContext_ConfluenceTenantContext_editions_Editions =
  {
    __typename?: "Editions";
    confluence: ConfluenceEdition;
  };
export type AdminKeyEligibilityQuery_confluenceTenantContext_ConfluenceTenantContext =
  {
    __typename?: "ConfluenceTenantContext";
    editions: AdminKeyEligibilityQuery_confluenceTenantContext_ConfluenceTenantContext_editions_Editions;
  };
export type AdminKeyEligibilityQuery_user_AtlassianUser_confluence_ConfluenceUser_roles_GraphQLConfluenceUserRoles =
  {
    __typename?: "GraphQLConfluenceUserRoles";
    canBeSuperAdmin: boolean;
  };
export type AdminKeyEligibilityQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    roles: AdminKeyEligibilityQuery_user_AtlassianUser_confluence_ConfluenceUser_roles_GraphQLConfluenceUserRoles | null;
  };
export type AdminKeyEligibilityQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  confluence: AdminKeyEligibilityQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type AdminKeyEligibilityQuery_Query = {
  __typename?: "Query";
  tenant: AdminKeyEligibilityQuery_tenant_Tenant;
  confluenceTenantContext: AdminKeyEligibilityQuery_confluenceTenantContext_ConfluenceTenantContext | null;
  user: AdminKeyEligibilityQuery_user_AtlassianUser | null;
};
export type AdminKeyEligibilityQueryVariables = Exact<{
  [key: string]: never;
}>;
export type AdminKeyEligibilityQuery = AdminKeyEligibilityQuery_Query;
